import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KakobuySpreadsheetGuide from "../pages/kakobuy-spreadsheet-guide/page";
import CSSBuySpreadsheetGuide from "../pages/cssbuy-spreadsheet-guide/page";
import SuperbuySpreadsheetGuide from "../pages/superbuy-spreadsheet-guide/page";
import OopbuySpreadsheetGuide from "../pages/oopbuy-spreadsheet-guide/page";
import KakobuySpreadsheetSneakers from "../pages/kakobuy-spreadsheet-sneakers/page";
import KakobuySpreadsheetFashion from "../pages/kakobuy-spreadsheet-fashion/page";
import KakobuySpreadsheetElectronics from "../pages/kakobuy-spreadsheet-electronics/page";
import KakobuySpreadsheetBeginners from "../pages/kakobuy-spreadsheet-beginners/page";
import KakobuySpreadsheetBestFinds from "../pages/kakobuy-spreadsheet-best-finds/page";
import KakobuySpreadsheetAccessories from "../pages/kakobuy-spreadsheet-accessories/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/kakobuy-spreadsheet-guide", element: <KakobuySpreadsheetGuide /> },
  { path: "/cssbuy-spreadsheet-guide", element: <CSSBuySpreadsheetGuide /> },
  { path: "/superbuy-spreadsheet-guide", element: <SuperbuySpreadsheetGuide /> },
  { path: "/oopbuy-spreadsheet-guide", element: <OopbuySpreadsheetGuide /> },
  { path: "/kakobuy-spreadsheet-sneakers", element: <KakobuySpreadsheetSneakers /> },
  { path: "/kakobuy-spreadsheet-fashion", element: <KakobuySpreadsheetFashion /> },
  { path: "/kakobuy-spreadsheet-electronics", element: <KakobuySpreadsheetElectronics /> },
  { path: "/kakobuy-spreadsheet-beginners", element: <KakobuySpreadsheetBeginners /> },
  { path: "/kakobuy-spreadsheet-best-finds", element: <KakobuySpreadsheetBestFinds /> },
  { path: "/kakobuy-spreadsheet-accessories", element: <KakobuySpreadsheetAccessories /> },
  { path: "*", element: <NotFound /> },
];

export default routes;